import React, { useState } from 'react';

const reviewsData = [
  {
    text: "Leafwell Farm offers the perfect blend of nature, work, live and community. Our properties are purpose built for the nature oriented digital nomad, retiree explorers and work from home humans seeking a better life experience.",
    name: "Amy Cherry",
    designation: <p className="text-sm text-gray-600">Partner, Leafwell Farm <br /> Founder, Shou Sugi Ban House</p>,
    img: "/images/amy.png",
  },
];

const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextReview = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % reviewsData.length);
  };

  const prevReview = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + reviewsData.length) % reviewsData.length);
  };

  return (
    <section className="relative flex flex-col items-center justify-center bg-[#ede9df] p-8 py-8 md:py-16 pb-16 md:pb-32 md:max-h-screen rounded-xl">
      <div className="max-w-3xl flex flex-col items-center text-center space-y-4">
        <h2 className="text-[14px] font-semibold tracking-wider text-[#132430] uppercase">Our Mission</h2>
        <p className="w-[85%] md:w-full text-[16px] md:text-[24px] font-light italic text-gray-900">“{reviewsData[currentIndex].text}”</p>
        <div className="flex flex-col items-center justify-center space-x-2">
          <img src={reviewsData[currentIndex].img} alt={reviewsData[currentIndex].name} className="h-[80px] rounded-full" />
          <div>
            <p className="text-[18px] font-semibold text-[#1b1b1b]">{reviewsData[currentIndex].name}</p>
            {reviewsData[currentIndex].designation}
          </div>
        </div>
      </div>

      {/* <button
        className="absolute left-2 md:left-6 top-1/2 transform -translate-y-1/2 block-circle-light"
        onClick={prevReview}
      >
        <img src="/icons/prev_black.svg" alt="" />
      </button> */}
      {/* <button
        className="absolute right-2 md:right-6 top-1/2 transform -translate-y-1/2 block-circle-light"
        onClick={nextReview}
      >
        <img src="/icons/next_black.svg" alt="" />
      </button> */}
    </section>
  );
};

export default Reviews;
